import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { AuthServiceService } from '../../shareModule/services/auth-service.service';
import { LocalServiceService } from '../../shareModule/services/local-service.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { HttpClient } from '@angular/common/http';
import { NewSignupModalComponent } from '../new-signup-modal/new-signup-modal.component';
import { NewForgotPasswordComponent } from '../new-forgot-password/new-forgot-password.component';
import Swal from 'sweetalert2';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-new-login-modal',
  templateUrl: './new-login-modal.component.html',
  styleUrls: ['./new-login-modal.component.scss']
})
export class NewLoginModalComponent implements OnInit {

  @ViewChild('input1', {static: false}) inputEl: ElementRef;

  userSignIn: FormGroup;
  submitted = false;
  error = "";
  yourIp: any;
  re: string;
  rp: string;
  rc: string;
  isChecked: any;
  imgUrl = environment.ImageUrl;

  constructor(public activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private http: HttpClient,
    private auth: AuthServiceService,
    private local: LocalServiceService,
    private router: Router,
    private formBuilder: FormBuilder) { }

  ngOnInit(): void {
    this.userSignIn = this.formBuilder.group({
      usersEmail: ['', [Validators.required, Validators.email]],
      usersPassword: ['', [Validators.required, Validators.minLength(5)]],
    });
    this.getIPAddress();
    const getRememberMe = this.local.getRememberMe();
    this.rc = getRememberMe.rc;

    if(this.rc == 'true') {
      this.userSignIn.patchValue({
        usersEmail: getRememberMe.re.trim(),
        usersPassword: getRememberMe.rp.trim()
      });
    }
  }

  ngAfterViewInit() {
    setTimeout(() => this.inputEl.nativeElement.focus());
  }

  get userIn() { return this.userSignIn.controls; }

  usersignin() {
    this.submitted = true;
    if (this.userSignIn.invalid) {
      return;
    }

    let myIp = this.local.getMyIp();

    if (!myIp) {
      myIp = this.yourIp;
    }

    let data = { 'email': this.userIn.usersEmail.value, 'password': this.userIn.usersPassword.value, 'type': 0, 'ip': '' };

    if(this.isChecked && data.email.trim() != '' && data.password.trim() != '') {
      this.local.setRememberMe(data.email, data.password, this.isChecked);
    }

    if(!this.isChecked) {
      this.local.setRememberMe('', '', this.isChecked);
    }

    this.auth.login(data).subscribe((response: any) => {
      
      if(response.body.is_email_verified == 1) {
        this.toastr.success('Logged in Successfully');
        this.modalService.dismissAll();
        this.local.saveLoginUserData(response.body);

        if(response.body.is_blocked == 1) {
          this.router.navigate(['/admin/new-dashboard'], { queryParams: { status: 'blocked' } });
        } else {
          this.checkPendingMassMessage(response.body.id);
          this.router.navigate(['/admin/new-dashboard']);
        }
        // let data = { 'ipAddress': myIp.ip };
        // this.auth.save_ip_address(data).subscribe((response: any) => {
        // }, (e) => {
        // })
      } else {
        Swal.fire({
          title: 'Warning',
          text: "Please verify your email send on registered email address. After successful verifictaion, login process can be completed. Verifiction email may appear in junk/spam folder.",
          icon: 'warning',
          showDenyButton: true,
          confirmButtonColor: '#141631',
          denyButtonColor: '#33D4A0',
          confirmButtonText: 'OK',
          denyButtonText: 'RESEND EMAIL',
        }).then((result) => {
          if (result.isConfirmed) {
            
          } else if (result.isDenied) {
            this.resend_verification_email(response.body.id);
          }
        })
      }
    }, (e) => {
      if (e.status == 400) {
        this.toastr.error(e.error.message)
        this.modalService.dismissAll()
      }
    });
  }

  resend_verification_email(id) {
    let formData = new FormData();
    formData.append("id", id);
    this.auth.signup_resend_verification_email(formData).subscribe((response: any) => {
      Swal.fire({
        title: 'Email sent!',
        text: "We have sent an email with a confirmation link to your email address. Please check your junk mail if you did not receive any Email notification.",
        icon: 'success',
        confirmButtonColor: '#141631',
        confirmButtonText: 'OK'
      })
      this.modalService.dismissAll();
    }, (e) => {
      if (e.status == 400) {
        this.toastr.error(e.error.message)
        this.modalService.dismissAll()
      }
    });
  }

  dismiss() { this.modalService.dismissAll(); }

  getIPAddress() {
    this.http.get("https://api.ipify.org?format=json").subscribe((res: any) => {
      this.yourIp = res;
    });
  }

  open_signup_modal() {
    this.modalService.dismissAll();
    this.modalService.open(NewSignupModalComponent, { size: 'lg', ariaLabelledBy: 'modal-basic-title', windowClass: 'v2_login_model' });
  }

  open_forgot_password_modal() {
    this.modalService.dismissAll();
    this.modalService.open(NewForgotPasswordComponent, { size: 'lg', ariaLabelledBy: 'modal-basic-title', windowClass: 'v2_login_model' });
  }
  
  remember_me(event) {
    // let checked = event.target.checked;
    // let email = this.userIn.usersEmail.value;
    // let password = this.userIn.usersPassword.value;
    // if(checked && email.trim() != '' && password.trim() != '') {
    //   this.local.setRememberMe(email, password, checked);
    // }
    // if(!checked) {
    //   this.local.setRememberMe('', '', checked);
    // }
    this.isChecked = event.target.checked;
  }

  checkPendingMassMessage(adminId) {
    let formData = new FormData();
    formData.append("adminId", adminId);
    this.auth.pendingMassMessage(formData).subscribe((response: any) => {
      if(response.body.length) {
        let html = ``;
        if(response.body[0].image.trim() != '') {
          html += `<img loading="lazy" src="${this.imgUrl}${response.body[0].image}" style="border-radius: 4px; width: 80%; margin-top: 20px;">`;
        }
        html += `<p style="padding: 30px 10px 0px 10px; font-weight: 800;">${response.body[0].title}</p>
                  <p style="padding: 20px 20px 0px 20px; font-weight: 600;">${response.body[0].description}</p>`;
        Swal.fire({
          html: html,
          confirmButtonText: '<i class="fa fa-thumbs-up"></i> Great!'
        })
      }
    }, (e) => {
      if (e.status == 400) {
        this.toastr.error(e.error.message)
        this.modalService.dismissAll()
      }
    });
  }

}
